<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
// CART CHECKBOX START
$(function () {
    const navEntries = performance.getEntriesByType("navigation");

    for (const entry of navEntries) {
        console.log(entry.type);
        if (entry.type === "back_forward") {
          setTimeout(function () {
              $("#cst_cart_conditions").prop("checked", false);
          }, 0);
          break;
        }
    }
});
// CART CHECKBOX END

$(window).on("scroll", function () {
  var $sidebar = $(".halo-productView-left"), 
      $header = $("header"), 
      headerHeight = $header.outerHeight(), 
      windowWidth = $(window).width();
  var scrollTop = $(window).scrollTop();
  if ($('.halo-productView-left').length > 0 && windowWidth >= 768) {
    if (scrollTop > headerHeight) {
        $sidebar.addClass("sticky-active");
        $sidebar.css('top', headerHeight+'px');
    } else {
        $sidebar.removeClass("sticky-active");
        $sidebar.css('top', '0');
    }
  }
});

$(document).ready(function(){
  // ============================== PRODUCT PAGE DELIVERY BLOCK
  $('[href="#delivery-info"]').on('click', function(e){
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $("#tab-delivery").offset().top - 150
    }, 500);
    $("#tab-delivery .toggle-title:not(.active)").trigger('click');
  })
  $(".scroll-to-delivery").click(function(e) {
      e.preventDefault();
      $('html, body').animate({
          scrollTop: $("#cusboxpostcode").parents('.delivery-product-tab').length > 0 ? $("#cusboxpostcode").parents('.delivery-product-tab').offset().top - 180 : $("#cusboxpostcode").offset().top - 180
      }, 500);
  });

  // ============================== TRADE PAGE START
  $('[name="customer[phone]"]').on('keyup',function(){
    var get_field = $(this).val();
    $('.phone_number').attr('value',get_field);
  })
  $("select").each(function (i, select) {
    SetSelectColor(select);
  });
  $("select option").css('color', 'black');
  $("select option:first-child[value='']").css('color', '#868686');
  $("select").change(Select_Changed);           
  function Select_Changed() {
    SetSelectColor(this);   
  }    
  function SetSelectColor(select) {
    var value = $(select).val();
    $(select).css('color', value != 'not_value' ? 'black' : '#868686');
  }
  //validate mail
  function ValidateEmail(input) {
      var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;              
      if (input.val().match(validRegex)) {
          input.closest('.form-field').find('.field_error').remove();
          input.removeClass('hasError');
          return true;
      } else {
          input.closest('.form-field').find('.field_error').remove();
          input.closest('.form-field').append('<span class="field_error">Email is invalid!</span>');
      }
  }
  function Validatephone(input) {
    const phoneRegex = /^[\+\-]?[0-9\-\s]+$/;
    if (phoneRegex.test(input.val())) {
    // if($.isNumeric(input.val())){
       // if (input.val().length < 10) {
       //   input.closest('.form-field').find('.field_error').remove();
       //   input.closest('.form-field').append('<span class="field_error">Phone number must be of 10 digit!</span>');
       //   return false;
       // } else {
          input.closest('.form-field').find('.field_error').remove();
          input.removeClass('hasError');
          return true;
       // }
     } else {
        input.closest('.form-field').find('.field_error').remove();
        input.closest('.form-field').append('<span class="field_error">Phone number is invalid!</span>');
        return false;
     }
  }
  function AddressValidation(get_this){
    var form = $('.third_poup_wrp [action="/account/addresses"]');
    var company = form.find('input[name="address[company]"]');
    var address1 = form.find('input[name="address[address1]"]');              
    var city = form.find('input[name="address[city]"]');
    var postCode = form.find('input[name="address[zip]"]');
    var x = true;
    console.log(get_this, form, 'form');
    if (company.val() == '') {
        if (!company.hasClass('hasError')) {
            company.addClass('hasError');
            company.closest('.form-field').append('<span class="field_error">Company is required</span>');
        }    
        x = false;
    } else {
      company.closest('.form-field').find('.field_error').remove();
      company.removeClass('hasError');
    }
    if (address1.val() == '') {
        if (!address1.hasClass('hasError')) {
            address1.addClass('hasError');
            address1.closest('.form-field').append('<span class="field_error">Address 1 is required</span>');
        }    
        x = false;
    } else {
      address1.closest('.form-field').find('.field_error').remove();
      address1.removeClass('hasError');
    }
    if (city.val() == '') {
        if (!city.hasClass('hasError')) {
            city.addClass('hasError');
            city.closest('.form-field').append('<span class="field_error">City is required</span>');
        }    
        x = false;
    } else {
      city.closest('.form-field').find('.field_error').remove();
      city.removeClass('hasError');
    }
    if (postCode.val() == '') {
        if (!postCode.hasClass('hasError')) {
            postCode.addClass('hasError');
            postCode.closest('.form-field').append('<span class="field_error">Post code is required</span>');
        }    
        x = false;
    } else {
      postCode.closest('.form-field').find('.field_error').remove();
      postCode.removeClass('hasError');
    }
    if (x == false) {
      return false;
    }
  }
  function PasswordValidation(get_this){
     var password = $('#RegisterForm-password').val();
     var confirmPassword = $('#RegisterForm-confirmation-password').val();

      $('#RegisterForm-password').closest('.form-field').find('.field_error').remove();
      $('#RegisterForm-confirmation-password').closest('.form-field').find('.field_error').remove();
    
      if ($.trim(password) === '') {
          $('#RegisterForm-password').closest('.form-field').append('<span class="field_error">Password fields cannot be blank</span>');
          return false;
      } 
      if ($.trim(password).length < 8) {
         $('#RegisterForm-password').closest('.form-field').append('<span class="field_error">Password must be atleast of 8 characters</span>');
         return false;
      }
      if ($.trim(confirmPassword) === '') {
          $('#RegisterForm-confirmation-password').closest('.form-field').append('<span class="field_error">Password fields cannot be blank</span>');
          return false;
      } 
      if ($.trim(confirmPassword).length < 8) {
         $('#RegisterForm-confirmation-password').closest('.form-field').append('<span class="field_error">Password must be atleast of 8 characters</span>');
         return false;
      }
      if ($.trim(password) !== $.trim(confirmPassword)) {                  
          // console.log(password,'password');
          // console.log(confirmPassword,'confirmPassword');
          $('#RegisterForm-confirmation-password').closest('.form-field').append('<span class="field_error">Passwords do not match. Please re-enter.</span>');  
          event.preventDefault();
          return false;
      } else {
          var data_id = get_this.attr('data-id');
          $('.account_popup').removeClass('active');
          $('#'+data_id).addClass('active');
          submitForm('#create_customer');
      }
  }
  function FormValidation(get_this){             
      var form = get_this.closest('.account_popup');
      var first_name = form.find('input[name="customer[first_name]"]');
      var last_name = form.find('input[name="customer[last_name]"]');              
      var email = form.find('input[name="customer[email]"]');
      var phone_number =  form.find('input[name="customer[phone]"]');                  
      var choose_tag = form.find('.form-input_tag');
      var x = true;
     if (first_name.val() == '') {
        if (!first_name.hasClass('hasError')) {
            first_name.addClass('hasError');
            first_name.closest('.form-field').append('<span class="field_error">First Name is required</span>');
        }    
        x = false;
    } else {
      first_name.closest('.form-field').find('.field_error').remove();
      first_name.removeClass('hasError');
    } 
    if (last_name.val() == '') {
        if (!last_name.hasClass('hasError')) {
            last_name.addClass('hasError');
            last_name.closest('.form-field').append('<span class="field_error">Last Name is required</span>');
        }   
        x = false;
    } else {
      last_name.closest('.form-field').find('.field_error').remove();
      last_name.removeClass('hasError');
    }     
    if (email.val() == '') {
        if (!email.hasClass('hasError')) {
            email.addClass('hasError');
            email.closest('.form-field').find('.field_error').remove();
            email.closest('.form-field').append('<span class="field_error">Email is required</span>');
        }
        x = false;
    } else {
        x = ValidateEmail(email);
    }
    if (phone_number.val() == '') {
        x = false;
        if (!phone_number.hasClass('hasError')) {
            phone_number.addClass('hasError');
            phone_number.closest('.form-field').find('.field_error').remove();
            phone_number.closest('.form-field').append('<span class="field_error">Phone is required</span>');
        }
    } else {
        x = Validatephone(phone_number);
    }
     if (choose_tag.val() == 'not_value') {
      x = false;
      if (!choose_tag.hasClass('hasError')) {
          choose_tag.addClass('hasError');
          choose_tag.closest('.form-field').find('.field_error').remove();
          choose_tag.closest('.form-field').append('<span class="field_error">Please select Option</span>');
      }
    } else {
        choose_tag.closest('.form-field').find('.field_error').remove();
        choose_tag.removeClass('hasError');
    }
     if(x == false) {
        return false;
     } else {
        var data_id = get_this.attr('data-id');
        $('.account_popup').removeClass('active');
        $('#'+data_id).addClass('active');
        window.customer_details = {
          "name" : first_name.val() + ' ' + last_name.val(),
          "email": email.val(),
          "phone": phone_number.val(),
          "tag": choose_tag.val()          
        };
     }                 
  }
  function submitForm(formSelector) {      
      var $form = $(formSelector);
      console.log("Form to submit:", $form);
      var formData = {
          form: $form,
          action: $form.attr('action')
      };
      console.log('Serialized form data:', formData.form.serialize());
      $.ajax({
          type: 'POST',
          url: formData.action,
          data: formData.form.serialize(),                              
          beforeSend: function() {
              formData.form.addClass('sending');  
              $('#third_popup .popup_top_title').hide();
              $('#third_popup .third_poup_wrp').html('<img src="https://cdn.shopify.com/s/files/1/0427/7823/0945/files/animated_loader_gif_n6b5x0.gif?v=1721903534">');
          },
          success: function(data) {
            //console.log('Success:', data);  
            if(data.indexOf('please click the link included to verify your email address.') !== -1 || data.indexOf('This email address is already associated with an account') !== -1){
              $('#third_popup .popup_top_title').hide();
              
              // if(data.indexOf('please click the link included to verify your email address.') !== -1){
              //   $('#third_popup .third_poup_wrp').html('<p><span class="field_error">Your email address is already registered as a customer. To request access to a trade account, please contact our team directly.</span></p>');
              // } else {
              //   $('#third_popup .third_poup_wrp').html('<p><span class="field_error">Your email address is already registered as a customer. To request access to a trade account, please contact our team directly.</span></p>');
              // }
              $('#third_popup .third_poup_wrp').empty();
              
              $('.third_poup_wrp_customer').show();
              $('.third_poup_wrp_customer .trade-contact-form').find('#trade-name-ff').val(window.customer_details.name);
              $('.third_poup_wrp_customer .trade-contact-form').find('#trade-email-ff').val(window.customer_details.email);
              $('.third_poup_wrp_customer .trade-contact-form').find('#trade-phone-ff').val(window.customer_details.phone);
              $('.third_poup_wrp_customer .trade-contact-form').find('#trade-iama-ff').val(window.customer_details.tag);              
            }else{
              $.get("/account/addresses?view=address_data", function(data){
                var get_data = $(data).html();         
                $('#third_popup .popup_top_title').show();
                $('#third_popup .third_poup_wrp').html(get_data);
              })
            }
          },
          error: function(data) {              
              console.log('Error:', data);
              // formData.form.find('.errors_div').html(data.responseText);
            
              const $html = $(data.responseText);
              const contentDescText = $html.find(".content--desc").text().trim();
              // console.log("Text from .content--desc", contentDescText.replace('Return to the previous page.',''));
            
              formData.form.removeClass('sending');         
              $('#third_popup .popup_top_title').hide();
              $('#third_popup .third_poup_wrp').html('<p><span class="field_error">'+ contentDescText.replace('Return to the previous page.','') +'</span></p>');
              $('.third_poup_wrp_customer').show();
          }
      });
  }
  $('.submit-value').on('click',function (event) {
    event.preventDefault();             
    var get_this = $(this), data_id = get_this.attr('data-id'), customer_found = $(this).data('customer-found');
    if(customer_found && $(this).attr('data-id') == 'third_popup'){
      $('.account_popup').removeClass('active');
      $('#'+data_id).addClass('active');
      submitForm('#create_customer');
    } else {
      if(data_id == 'second_popup'){ 
        FormValidation(get_this);
      } else if (data_id == 'first_popup'){
         $("body").addClass('scroll_active');
         $('.account_popup').removeClass('active');
         $('#'+data_id).addClass('active');
      } else if (data_id == 'third_popup'){              
        PasswordValidation(get_this);                                          
      }    
    }
  })
  // Add Tag in Hidden Field
  // $('.form-input_tag').on('change', function(event) {                  
  //   var hiddenTagValue = $('.get_input').val();
  //   var selectedProfileValue = $(this).val();                                                          
  //   var combinedTags = hiddenTagValue + ',' + selectedProfileValue; 
  //   $('.hidden_input_tag').val(combinedTags); 
  // })
});
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->